import { OnInit, AfterViewInit, Directive } from '@angular/core';
import { Router } from '@angular/router';

import { TranslationService } from '../../services/translation.service';
import { AuthenticationService } from '../../services/authentication.service';
import { AppConfig } from '../../app.config';
import { navutils } from '../../common/navutils';


@Directive()
export abstract class BaseDashboardComponent implements OnInit, AfterViewInit {

  public bar_width = 414;
  // gets the user rights to determinate the allowed dashboards
  public rights: any;
  // gets the current building id (can be empty for the whole site)
  public building_id: any;

  constructor(protected router: Router,
    protected translation_service: TranslationService,
    protected authentication_service: AuthenticationService,
  ) {
  }

  async ngOnInit() {
    this.rights = this.authentication_service.getUserRights();
    this.bar_width = 138 * (this.canEquipments() + this.canMaintenance() + this.canBattery());
    await this.onInitialize();
    await this.onGetData();
  }

  protected abstract onGetData();

  protected abstract onInitialize();

  async ngAfterViewInit() {
  }

  protected navigateDashboard() {
    navutils.NavigateToDashboard(this.router, this.building_id, null, null, true);
  }

  protected navigateMaintenanceDashboard() {
    navutils.NavigateToDashboardMaintenance(this.router, this.building_id);
  }

  protected navigateBatteryDashboard() {
    navutils.NavigateToDashboardBattery(this.router, this.building_id);
  }

  protected canEquipments() {
    return this.rights['right_statistics'] && AppConfig.front_settings && AppConfig.front_settings.views.show_dashboard;
  }

  protected canMaintenance() {
    return this.rights['right_maintenance'];
  }

  protected canBattery() {
    return this.rights['right_statistics'];
  }
}